export default "__VITE_ASSET__BRra73VC__"